import { createFileRoute } from '@tanstack/react-router';
import { PeopleTopic } from '../screens/company/topics/PeopleTopic';
import { peopleSearch } from '../screens/company/people-search';

export const Route = createFileRoute('/t/$tenant/settings/company/people')({
  validateSearch: peopleSearch,
  component: PeopleTopic,
});
